import client from './client';

export const listCourses = (companyId, siteId) =>
  client.get('/api/hse/courses', { params: { companyId, siteId } }).then(r => r.data);

export const createCourse = (data) =>
  client.post('/api/hse/courses', data).then(r => r.data);

export const updateCourse = (id, data) =>
  client.put(`/api/hse/courses/${id}`, data).then(r => r.data);

export const deleteCourse = (id) =>
  client.delete(`/api/hse/courses/${id}`).then(r => r.data);

export const getEmployeeTraining = (employeeId) =>
  client.get(`/api/hse/employees/${employeeId}/training`).then(r => r.data);

export const assignTraining = (employeeId, data) =>
  client.post(`/api/hse/employees/${employeeId}/training`, data).then(r => r.data);

export const updateTrainingRecord = (employeeId, recordId, data) =>
  client.put(`/api/hse/employees/${employeeId}/training/${recordId}`, data).then(r => r.data);

export const addNote = (employeeId, data) =>
  client.post(`/api/hse/employees/${employeeId}/notes`, data).then(r => r.data);

export const bulkAssign = (data) =>
  client.post('/api/hse/bulk-assign', data).then(r => r.data);

export const bulkPass = (data) =>
  client.post('/api/hse/bulk-pass', data).then(r => r.data);

export const getCourseRoster = (courseId) =>
  client.get(`/api/hse/courses/${courseId}/roster`).then(r => r.data);

export const getVisitorTraining = (visitorId) =>
  client.get(`/api/hse/visitors/${visitorId}/training`).then(r => r.data);

export const assignVisitorTraining = (visitorId, data) =>
  client.post(`/api/hse/visitors/${visitorId}/training`, data).then(r => r.data);

export const updateVisitorTraining = (visitorId, recordId, data) =>
  client.put(`/api/hse/visitors/${visitorId}/training/${recordId}`, data).then(r => r.data);

export const bulkPassVisitors = (data) =>
  client.post('/api/hse/visitors/bulk-pass', data).then(r => r.data);

export const listAttendance = (courseId) =>
  client.get(`/api/hse/courses/${courseId}/attendance`).then(r => r.data);

export const addAttendance = (courseId, data) =>
  client.post(`/api/hse/courses/${courseId}/attendance`, data).then(r => r.data);

export const deleteAttendance = (recordId) =>
  client.delete(`/api/hse/attendance/${recordId}`).then(r => r.data);

export const getSitePeople = (siteId) =>
  client.get(`/api/hse/sites/${siteId}/people`).then(r => r.data);
